export class Alert {
    constructor() {
        this.message = "";
        this.variant = "";
    }
    info(message) {
        this.set(message, "primary");
    }
    warn(message) {
        this.set(message, "warning");
    }
    error(message) {
        this.set(message, "error");
    }
    success(message) {
        this.set(message, "success");
    }
    set(message, variant) {
        this.message = message;
        this.variant = variant;
    }
    clear() {
        this.message = "";
    }
    get hasMessage() {
        return (this.message ? true : false);
    }
}
